const SCHEMAS = {};

export const addListSchema = (name, schema) => {
  SCHEMAS[name] = schema;
}

export const getListSchema = (name) => {
  return SCHEMAS[name];
}
